import {
  createDarkTheme,
  createLightTheme,
  type BrandVariants,
  type Theme,
} from '@fluentui/react-components';

/**
 * Legends Global skin. Palettes come from the two Legends design files:
 * light = the "Section 10" interactive deck, dark = "Venue Factory Command".
 */

export const LEGENDS = {
  blue: '#009CDE',
  blueDark: '#006B99',
  blueBg: '#E3F4FB',
  green: '#3F9C35',
  amber: '#B86E00',
  red: '#B3261E',
  // light skin
  white: '#FFFFFF',
  panel: '#F5F7F9',
  text: '#63666A',
  dense: '#3A3D40',
  mid: '#888B8D',
  light: '#D9DCDE',
  // dark skin
  navy: '#0F1720',
  navy2: '#16202B',
  navyPanel: '#1A2632',
  navyPanel2: '#213040',
  navyPanel3: '#27384A',
  navyLine: '#3A4858',
  navyText: '#E8EDF2',
  navyMuted: '#B9C3CE',
  navyDim: '#9AA6B2',
} as const;

/** Brand ramp around Legends blue (#009CDE at 100, #006B99 at 80). */
const legendsBrand: BrandVariants = {
  10: '#001520',
  20: '#002233',
  30: '#002E45',
  40: '#003A57',
  50: '#00476A',
  60: '#00547C',
  70: '#00618F',
  80: '#006B99',
  90: '#0085BD',
  100: '#009CDE',
  110: '#24ABE4',
  120: '#47B9E9',
  130: '#6BC7EE',
  140: '#8ED5F3',
  150: '#B2E3F8',
  160: '#E3F4FB',
};

export const legendsLightTheme: Theme = {
  ...createLightTheme(legendsBrand),
  colorNeutralForeground1: LEGENDS.dense,
  colorNeutralForeground2: LEGENDS.text,
  colorNeutralForeground3: LEGENDS.mid,
  colorNeutralBackground2: LEGENDS.panel,
  colorNeutralStroke2: LEGENDS.light,
  colorNeutralStroke3: '#E8EAEC',
  colorBrandForeground1: LEGENDS.blueDark,
  colorBrandBackground2: LEGENDS.blueBg,
  colorPaletteGreenForeground1: LEGENDS.green,
};

export const legendsDarkTheme: Theme = {
  ...createDarkTheme(legendsBrand),
  colorNeutralBackground1: LEGENDS.navyPanel,
  colorNeutralBackground1Hover: LEGENDS.navyPanel2,
  colorNeutralBackground1Pressed: LEGENDS.navyPanel3,
  colorNeutralBackground2: LEGENDS.navy,
  colorNeutralBackground3: LEGENDS.navy2,
  colorNeutralBackground4: LEGENDS.navyPanel2,
  colorSubtleBackgroundHover: LEGENDS.navyPanel2,
  colorNeutralForeground1: LEGENDS.navyText,
  colorNeutralForeground2: LEGENDS.navyMuted,
  colorNeutralForeground3: LEGENDS.navyDim,
  colorNeutralStroke1: LEGENDS.navyLine,
  colorNeutralStroke2: LEGENDS.navyLine,
  colorNeutralStroke3: '#2A3644',
  colorBrandForeground1: LEGENDS.blue,
  colorBrandForegroundLink: LEGENDS.blue,
  colorBrandStroke1: LEGENDS.blue,
  colorBrandBackground2: '#10283A',
};
